import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { BookDemoForm } from "@/components/BookDemoForm";
import { scrollToAnchor } from "@/components/ScrollToTop";

export function HeroContent() {
  const [showDemoForm, setShowDemoForm] = useState(false);

  const handleLearnMore = () => {
    scrollToAnchor("#learn-more-section");
  };

  return (
    <section
      className="flex w-[55%] flex-col items-start justify-start gap-6 pl-20 pr-16 3xl:pl-28 3xl:pr-20 4xl:pl-32 4xl:pr-24 max-lg:w-full max-lg:px-12 max-lg:py-10 max-lg:bg-horizon max-md:px-8 max-sm:px-4 max-sm:py-8 max-sm:gap-6 pt-[80px]"
      aria-labelledby="hero-heading"
    >
      <header>
        <h1 id="hero-heading" className="text-h2 text-foreground max-lg:text-h3 max-sm:text-h4">
          Simple, Secure, Reliable Connection for Older Adults
        </h1>
      </header>

      <p className="text-body-lg text-foreground">
        Older adults are often the hardest to reach and the least comfortable with technology. GrandPad gives healthcare
        organizations a simple, secure way to keep them consistently connected and engaged—strengthening communication
        and driving better health outcomes.
      </p>

      <div
        className="flex items-center gap-4 max-lg:flex-col max-lg:w-full max-sm:gap-3"
        role="group"
        aria-label="Call to action buttons"
      >
        <Button variant="primary" size="hero" onClick={() => setShowDemoForm(true)} className="max-lg:w-full">
          Book a Demo
        </Button>

        <Button variant="primary-outline" size="hero" onClick={handleLearnMore} className="max-lg:w-full">
          Learn More
        </Button>
      </div>

      <BookDemoForm open={showDemoForm} onOpenChange={setShowDemoForm} />
    </section>
  );
}
